"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActiveFeatureFlags = void 0;
const react_1 = require("react");
const usePostHog_1 = require("./usePostHog");
function useActiveFeatureFlags() {
    const client = (0, usePostHog_1.usePostHog)();
    const [featureFlags, setFeatureFlags] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (!client) {
            return;
        }
        return client.onFeatureFlags((flags) => {
            setFeatureFlags(flags);
        });
    }, [client]);
    return featureFlags;
}
exports.useActiveFeatureFlags = useActiveFeatureFlags;
